import { create } from "zustand"
import type { Subject } from "@/modules/study/entities/activities"

interface DailyCalendarFilterState {
  activeSubjects: Subject[]
  setActiveSubjects: (activeSubjects: Subject[]) => void
}

export const useDailyCalendarFilter = create<DailyCalendarFilterState>((set) => ({
  activeSubjects: [],
  setActiveSubjects: (activeSubjects) =>
    set(() => ({
      activeSubjects,
    })),
}))

export default useDailyCalendarFilter.getState()
